import { Article } from "../../models/Article";
import { UPSERT_ARTICLES } from "./actionTypes";

export const upsertArticles = (articles: Array<Article>) => {
    return {
        type: UPSERT_ARTICLES,
        payload: articles
    };
};
